export default "__VITE_ASSET__FE$0snBd__"